<template>
  <div>
    <script :id="id" type="text/plain"></script>
  </div>
</template>

<script>
export default {
  name: 'UE',
  props: {
    value: {
      type: String,
      default: ''
    },
    defaultMsg: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editor: null,
      isReady: false,
      handling: false // ⭐ 防止 contentChange 死循环
    }
  },
  mounted() {
    this.editor = UE.getEditor(this.id, this.config)
    this.editor.addListener('ready', () => {
      this.isReady = true
      const initContent = this.value || this.defaultMsg || ''
      this.editor.setContent(initContent)

      this.editor.addListener('contentChange', () => {
        if (this.handling) return
        this.handling = true

        // 1️⃣ 触发远程图片抓取（关键）
        this.editor.execCommand('catchimage')

        // 2️⃣ 抓取完成后，UE 会再次修改内容
        setTimeout(() => {
          const doc = this.editor.document
          if (!doc) return

          const imgs = doc.querySelectorAll('img')
          imgs.forEach(img => {
            const src = img.getAttribute('src')

            // 3️⃣ 此时 src 已经是 /upload/xxx.png
            if (src && src.startsWith('/upload/')) {
              img.setAttribute(
                'src',
                'https://img.mmzexpo.com' + src
              )
            }
          })

          // 4️⃣ 同步到 v-model
          const html = this.editor.getContent()
          this.$emit('input', html)

          this.handling = false
        }, 300)
      })
      // 监听图片上传成功
      this.editor.addListener('afterinsertimage', function (t, list) {
        console.log('图片上传成功:', list);
      })
      
      // 监听上传错误
      this.editor.addListener('uploadError', function(code, msg) {
          console.log('上传错误: ' + msg);
      });
    })
  },
  watch: {
    value(val) {
      if (this.isReady && val !== this.editor.getContent()) {
        this.editor.setContent(val)
      }
    }
  },
  methods: {
    getUEContent() {
      return this.editor ? this.editor.getContent() : ''
    },
    getUEContentTxt() {
      return this.editor ? this.editor.getContentTxt() : ''
    },

    /**
     * 处理富文本中的外链图片
     */
    async handleExternalImages(html) {
      const imgReg = /<img\b([^>]*?)>/gi
      let resultHtml = html
      resultHtml = resultHtml.replace(imgReg, (match, attrs) => {
        if (/referrerpolicy\s*=/i.test(attrs)) {
          return match
        }
        // 没有就添加 referrerpolicy="no-referrer" 微信浏览器 图片加载不成功////
        return `<img${attrs} referrerpolicy="no-referrer">`
      })

      return resultHtml
    },

  },
  beforeDestroy() {
    this.editor && this.editor.destroy()
  }
}
</script>
